export default (baseURLAndPath: string, size: string, imagePath: string): string => {
  const parts = imagePath.split('/');
  parts.splice(parts.length - 1, 0, size);
  // return config.api.baseUrl + config.api.basePaths.imageRead + '/' + parts.join('/');
  const base = baseURLAndPath.charAt(baseURLAndPath.length - 1) === '/' ? baseURLAndPath.substring(0, baseURLAndPath.length - 1) : baseURLAndPath;
  return base + '/' + parts.join('/');
};
